import { create } from "zustand";
import { persist } from "zustand/middleware";
import { axiosInstancev1 } from "../../lib/axiosInstance";
// import useAuthStore from "../useAuthStore"; // Not directly used in this function, token is from localStorage

const useProjectEnqStore = create(
  persist(
    (set, get) => ({
      isLoading: false,
      error: null,

      updateProjectStatus: async (projectId, key, reasonOrComment = "") => { // Changed param name
        if (get().isLoading) return; // Prevent multiple simultaneous calls
        set({ isLoading: true, error: null });

        try {
          const customerToken = localStorage.getItem('customerToken');
          if (!customerToken) {
            throw new Error("Customer token missing!");
          }

          let finalStatus;
          if (key === 'accept') {
            finalStatus = 'active'; 
          } else if (key === 'decline') {
            finalStatus = 'rejected'; 
          } else {
            finalStatus = key; 
          }

          const payload = { key, status: finalStatus }; 

          if (key === 'decline') {
            payload.rejectionReason = reasonOrComment; // Use reasonOrComment as rejectionReason
          } else if (key === 'hold') { 
            payload.holdComment = reasonOrComment;
          }
          // For 'accept' or other keys, no specific comment field is added by default here.
          // If a comment/reason is passed for 'completed' or other 'rejected' scenarios (like completion request rejection),
          // it's expected that the calling component will pass the appropriate `key` and `reasonOrComment`.

          const response = await axiosInstancev1.put(
            `/projects/${projectId}/status-by-key`,
            payload, 
            {
              headers: { 
                Authorization: `Bearer ${customerToken}`,
                'Content-Type': 'application/json'
              }
            }
          );

          if (response.data.success) {
            return response.data; 
          }
          
          throw new Error(response.data.message || "Failed to update project status (API success false)");

        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || "Failed to update project status";
          set({ error: errorMessage });
          return { success: false, message: errorMessage }; // Return error object for UI handling
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: "customer-project-actions-store", // Changed name for clarity
      getStorage: () => localStorage,
    }
  )
);

export default useProjectEnqStore;